import React from 'react';
import { 
  Home, Clock, Calendar, Users, MessageSquare, CalendarCheck, Settings, LogOut, 
  Menu, X, Bell, User, ChevronDown, FileText, Briefcase, Building, Monitor
} from 'lucide-react';

const WorkstreamPage = () => {
  return (
    <div className="max-w-4xl mx-auto text-center py-20">
      <div className="mb-8">
        <div className="inline-flex items-center justify-center w-24 h-24 bg-blue-100 rounded-2xl mb-6">
          <Briefcase size={48} className="text-blue-600" />
        </div>
      </div>
      
      <h1 className="text-5xl font-bold text-gray-900 mb-4">Workstream</h1>
      <p className="text-xl text-gray-600 mb-10 max-w-md mx-auto">
        Manage your projects, tasks, and team workflows in one place.
      </p>

      <div className="bg-white rounded-3xl shadow-xl p-10 max-w-lg mx-auto">
        <h2 className="text-2xl font-semibold mb-6 text-gray-800">Coming Soon</h2>
        <p className="text-gray-500 mb-8">
          Advanced project tracking, Kanban boards, Gantt charts, and team collaboration features are under development.
        </p>
        <div className="text-sm text-gray-400">Expected: Q3 2026</div>
      </div>
    </div>
  );
};

export default WorkstreamPage;